import { Component, OnInit, Renderer2, TemplateRef } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { Router } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'app-choose-profile',
  templateUrl: './choose-profile.component.html',
  styleUrls: ['./choose-profile.component.css']
})
export class ChooseProfileComponent implements OnInit {
  profiles: Array<any> = [];
  baseUrl: String;
  sidebarShow: boolean = false;
  profilesToAssign = null;
  selectedProfile: any;
  categories: Array<any> = [];
  user: any;
  video: String = 'assets/videos/Emotive registration tutorial.mp4';
  menuState: string = 'out';
  menuState1: string = 'out';
  videoStatus: Boolean = false;
  constructor(
    private apiService: ApiService,
    private router: Router,
    private renderer: Renderer2,
    private modalService: BsModalService,
    public translations: TranslationService
  ) { }

  ngOnInit() {
    this.getRequiredData();
    this.apiService.getClient().subscribe((res: any) => {
      if (res.data.video) {
        this.video = res.data.video;
      } 
    });
  }

  getRequiredData() {
    this.user = this.apiService.user;
    if (this.user.profiles) {
      this.profilesToAssign = this.user.profiles._id;
    }
    this.baseUrl = this.apiService.url + '/uploads/';
    this.apiService.getProfiles().subscribe((res: any) => {
      let profileSimilarityCount = JSON.parse(localStorage.getItem("ProfileSimilarityCount"));
      let sortedProfileCount = Object.keys(profileSimilarityCount).sort(function(a,b){return profileSimilarityCount[b] - profileSimilarityCount[a]});
      
      for(let i=0; i < sortedProfileCount.length; i++) {
        let profile = res.data.filter((p) => p._id == sortedProfileCount[i]);
        this.profiles.push(profile[0]);
      }
      console.log(this.profiles);
    });
    this.apiService.getCategories().subscribe((res: any) => {
      this.categories = res.data;
    });
  }

  modalRef: BsModalRef;
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'tour-modal tutorial' });
  }

  toggleVideo(video) {
    !this.videoStatus ? video.play() : video.pause();
    this.videoStatus = !this.videoStatus;
  }

  openProfile(profile) {
    this.renderer.addClass(document.body, 'overlay');
    this.selectedProfile = profile;
    this.selectedProfile['impact'] = 0;
    this.selectedProfile['savings'] = 0;
    this.selectedProfile.goals = this.selectedProfile.categoryMap.map(g => {
      g['collapse'] = {
        'parent': false
      };
      g.category.goals.forEach((element, index) => {
        g['collapse'][index] = false;
        element.outcomes.forEach((out) => {
          if (out.impact) {
            this.selectedProfile['impact'] += out.impact;
          }
          if (out.savings) {
            this.selectedProfile['savings'] += out.savings;
          }
        });
      });
      return g;
    });
    this.menuState = this.menuState === 'out' ? 'in' : 'out';
  }


  closeProfile() {
    this.menuState = this.menuState === 'out' ? 'in' : 'out';
    this.renderer.removeClass(document.body, 'overlay');
  }

  checkProfile(event, profile) {
    if (event.target.checked) {
      return this.profilesToAssign = profile._id;
    } else {
      return this.profilesToAssign = null;
    }
  }

  checkStatus(profile) {
    if (this.profilesToAssign == profile._id) {
      return true;
    }
    return false;
  }


  updateUser() {
    let temp = [];
    temp.push(this.user._id);
    let formData = new FormData();
    formData.append('id', JSON.stringify(temp));
    if (this.profilesToAssign !== null) {
      formData.append('profiles', this.profilesToAssign);
    }
    formData.append('email', this.user.email);
    this.apiService.updateUser(formData).subscribe(() => {
      if (this.profilesToAssign !== null) {
        this.apiService.updateUserGoals({ profile: this.profilesToAssign, user: this.user._id }).subscribe((res) => {
          this.router.navigate(['/personal-info']);
        })
      } else {
        this.router.navigate(['/personal-info']);
      }
    });
  }
}
